<template>
    <DCard>
        <DTable
            :fields="fields"
            :items="hostingPlatforms.data"
        >
            <template #actions="{item}">
                <td class="width text-right">
                    <div class="actions">
                        <DButton
                            icon="pencil"
                            mini
                            @click="editPage(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
    </DCard>
    <DPagination
        v-if="hostingPlatforms.last_page > 1"
        class="mt-3 pb-2"
        :active-page="hostingPlatforms.current_page"
        :pages="hostingPlatforms.last_page"
        @update:active-page="changePage"
    />
    <DFabs>
        <DFab
            icon="plus"
            :label="$t('common.create')"
            @click="createPage"
        />
    </DFabs>
</template>

<script setup>
import { router } from '@inertiajs/vue3'
import { computed, getCurrentInstance } from 'vue'

const { proxy } = getCurrentInstance()

const fields = computed(() => [
    { key: 'hostname', label: proxy.$t('settings_hosting_platforms.hostname') },
    { key: 'type', label: proxy.$t('settings_hosting_platforms.type') },
    { key: 'actions', label: '' }
])

defineProps({
    hostingPlatforms: {
        type: Object,
        default () {
            return {}
        }
    }
})

function editPage (item) {
    router.get(route('settings.hosting-platforms.edit', { hosting_platform: item.id }))
}

function createPage () {
    router.get(route('settings.hosting-platforms.create'))
}

function changePage (page) {
    const queryParameters = {}

    if (page !== 1) {
        queryParameters._query = { page }
    }

    router.get(route('settings.hosting-platforms.index', queryParameters))
}
</script>
